import { faLaptopMobile } from '@fortawesome/pro-solid-svg-icons'
import { useMediaQuery } from '@react-hookz/web'
import { clsx } from 'clsx'

import { Icon } from 'Components/Icon/Icon'

import { useTheme } from 'Hooks'

import { sanitizeHtml } from 'Utilities'

import { PORTAL_BREAKPOINTS } from 'Constants/constants'

import { Badge } from '../Badge/Badge'
import { Heading } from '../Heading/Heading'
import { PrimaryButton } from '../PrimaryButton/PrimaryButton'
import { TertiaryButton } from '../TertiaryButton/TertiaryButton'
import { Text } from '../Text/Text'
import type { BannerProps } from './Banner.types'

export const Banner = (props: BannerProps) => {
  const {
    buttonText,
    onButtonClick,
    showButton,
    className,
    imageSource,
    text,
    title,
    version = 'default',
    alt,
    badge,
  } = props

  const isFullHDDesktop = useMediaQuery(
    `(min-width: ${PORTAL_BREAKPOINTS.XXXL})`,
  )

  const { isTelekomTheme } = useTheme()

  const classNames = clsx(
    'Banner',
    version !== 'default' && `Banner-${version}`,
    className,
  )

  if (version === 'employee') {
    return (
      <div className={classNames}>
        <div className="Banner-content">
          <Badge
            className="align-self-center align-self-md-start"
            color={isTelekomTheme ? 'pink' : 'green'}
            rounded
            variant="secondary"
          >
            <>
              <Icon
                className="mx-1"
                height={14}
                icon={faLaptopMobile}
                width={19}
              />
              <span>{badge}</span>
            </>
          </Badge>
          <Heading
            as={2}
            className="text-center text-md-start mb-4 mb-md-6"
            size={3}
          >
            {title}
          </Heading>

          <Text
            className="text-center text-md-start"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(text),
            }}
          />
          {showButton && (
            <PrimaryButton
              className="align-self-center align-self-md-start"
              onClick={onButtonClick}
              size={'medium'}
            >
              {buttonText}
            </PrimaryButton>
          )}
        </div>

        <img alt={alt || title} src={imageSource} />
      </div>
    )
  }

  return (
    <div className={classNames}>
      {(version === 'default' || version === 'serviceApp') && (
        <div className="Banner-title-content">
          <div className="Banner-title">
            <Heading as={1} size={2}>
              {title}
            </Heading>
          </div>
        </div>
      )}

      <div className="Banner-content">
        <Heading as={1} className="Banner-compact-title" color="light" size={2}>
          {title}
        </Heading>

        <p
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(text),
          }}
        />
        {showButton && (
          <TertiaryButton
            onClick={onButtonClick}
            size={isFullHDDesktop ? 'large' : 'medium'}
          >
            {buttonText}
          </TertiaryButton>
        )}
      </div>

      <img alt={alt || title} src={imageSource} />
    </div>
  )
}
